<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <InvoiceSurchargesTable
          ref="invoiceSurchargesTable"
          :account-id="$route.params.accountId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import InvoiceSurchargesTable from '@/components/Application/Manage/Account/InvoiceSurchargesTable'

export default {
  components: {
    InvoiceSurchargesTable
  },
  data () {
    return {
      breadcrumb: {
        name: 'Invoice Surcharges',
        route: { name: 'manage-accounts-account-billings-invoicesurcharges', params: { accountId: this.$route.params.accountId } }
      }
    }
  },
  mounted () {
    this.actions = this.$refs.invoiceSurchargesTable.actions
  }
}
</script>
